"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assetUrl = void 0;
exports.assetUrl = function (filename, props) {
    return "" + props.data.filters.asset_url + filename;
};
//# sourceMappingURL=asset-url.js.map